import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import MultistepForm from "./forms";
import bgMain from "../assets/img/168.jpg";

export default function Demande() {
  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        paddingTop: "76px",
        overflow: "hidden",
      }}
    >
      {/* Fond image (dans la page, pas fixed) */}
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${bgMain})`,
          backgroundSize: "cover",
          backgroundPosition: "center center",
          zIndex: 0,
          pointerEvents: "none",
        }}
      />

      {/* Overlay sombre */}
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1,
          pointerEvents: "none",
        }}
      />

      <main style={{ position: "relative", zIndex: 2 }}>
        <MultistepForm />
      </main>
    </div>
  );
}
